import { ActionTypes } from "../constants/action-types";

export const setAuthentication = (val) => {
  return {
    type: ActionTypes.SET_AUTH,
    payload: val,
  };
};
